import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class HideChildNotebook extends PrimitiveValueObject<boolean> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: boolean): HideChildNotebook {
    return new HideChildNotebook(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '連絡帳を使用しない';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {};
  }

  /**
   * キー
   */
  static get key(): string {
    return 'hideChildNotebook';
  }

  /**
   * タイプ
   */
  static get type(): string {
    return 'boolean';
  }
}
